export default __webpack_public_path__ + "static/media/KZ.М.12.1633 black.888caa17.svg";